import { useTranslation } from "react-i18next";
import i18n, { translate as tr } from "../../i18n";
import React, { Component, useState, useEffect,lazy, Suspense } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import Sidebar from "../common/sidebar";
//import ProjectList from "../Projects/ProjectList";
import axios from "axios";
import ColorPicker from "../common/ColorPicker";
import Loader from "../common/loader";
import ProjectModal from "../Projects/projectModal";
import moment from "moment-timezone";
import Footer from "../common/footer";
import "../../assets/css/project-chart.css";

const ProjectList = lazy(()=> import("../Projects/ProjectList"));

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];



export const Projects = () => {
  useTranslation();
  const auth = useSelector((state) => state.auth);
  const canManageProjects = auth.workspace_role === "ADMIN" || auth.workspace_role === "MANAGER";
  const invite = useSelector(state => state.invite_ids);
  const [show, setShow] = useState(false);
  const [clientList, setClientList] = useState([]);
  const showClientFilter = clientList.length > 0;
  const [searchTerm, setSearchTerm] = useState("");
  const [reload, setReload] = useState(0);
  const [showoptions, setShowoption] = useState(false);
  const [status, setStatus] = useState(0);
  const [clientDD, setClientDD] = useState(false);
  const [projectNameDD, setProjectNameDD] = useState(false);
  const [clientArray, setClientArray] = useState([]);
  const [projectTerm, setProjectTerm] = useState("");
  const [is_sole_project_creator, setProjectCreator] = useState(false);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      const insideClientFilter = e.target.closest(".proj-filter-pill-wrap");
      if (!insideClientFilter) {
        setClientDD(false);
        setSearchTerm("");
        getClientList();
      }
      setProjectNameDD(false);
      setShowoption(false);
    };

    document.addEventListener("click", handleDocumentClick, true);

    if(auth.user_properties !== null && 
      auth.user_properties !== undefined) {
        let timeZone = auth.user_properties.timeZone;
        if(timeZone === "" || timeZone === null || timeZone === undefined) {
          moment.tz.setDefault();
        }
        else {
          timeZone = timeZone.split(' ')[0];
          moment.tz.setDefault(timeZone)
        }
      }
      else {
        moment.tz.setDefault();
      }

    getClientList();
    setStatus(1);

    return () => document.removeEventListener("click", handleDocumentClick, true);
  }, []);

  useEffect(() => {
    getWorkspaceInfo();
  }, [auth.workspace_id, auth.is_workspace_admin, auth.workspace_role, auth.token]);

  const handleProjectTerm = (e) => {
    setProjectTerm(e.target.value);
  };

  const handleSearchTerm = (e) => {
    setSearchTerm(e.target.value);
  };

  const getWorkspaceInfo = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post(
        "/api/workspace/listbyworkspaceid",
        body,
        config
      );
      if (res.status === 200) {
        res.data.results.map((item)=> {
          if(Number(item.id) === Number(workspace_id)) {
            if(item.is_sole_project_creator === 1) {
              if(
                auth.is_workspace_admin === 1 ||
                auth.workspace_role === "ADMIN" ||
                auth.workspace_role === "MANAGER"
              ) {
                setProjectCreator(true);
              }
              else {
                setProjectCreator(false);
              }
            }
            else {
              setProjectCreator(true);
            }
          }
      })
      }
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

  const getClientList = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ workspace_id, searchTerm });
      let res = await axios.post("/api/client/search", body, config);
      if (res.status === 200) {
        setClientList(res.data.results);
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const handleShow = () => {
    getClientList();
    setShow(true)
  };

  const selectAllClient = () => {
    setClientArray([]);
  };

  const selectNone = () => {
    setClientArray([]);
  };

  const handleClientCheck = (item) => {
    let newArr = [];
    if (!clientArray.includes(item)) {
      newArr = [...clientArray, item];
    } else {
      newArr = clientArray.filter((a) => a !== item);
    }
    setClientArray(newArr);
  };

  const showOptions = (showoptions) => {
    setShowoption(showoptions);
  };
  const selectOption = (event, id) => {
    setStatus(id);
    setShowoption(false);
  };

  const hideModal = () => {
    setShow(false)
  };

  const reloadFunction = () => {
    setReload(reload + 1);
  };

  return (
    <>
      <Sidebar />
      <div className='header'>
        <div className='container-fluid'>
          <div className='row' style={{ flexDirection: "column" }}>
            <div className='dash-page-header'>
              <div className='dash-page-title'>
                <h1>{tr("Projects")}</h1>
                <p>{tr("Organize active work, archived records, and client-linked delivery in one place.")}</p>
              </div>
              <div className='reports-right-item-cont tags-right-header-item'>
                {canManageProjects && (
                  <div className='create-new-tag-btn'>
                    <button
                      id='add-new-button'
                      onClick={handleShow}
                      disabled={is_sole_project_creator === true ? false : true}
                      style={{ backgroundColor: is_sole_project_creator === true ? "" : "#D1D1D1" }}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        viewBox='0 0 20 20'
                      >
                        <path
                          fill='#ffffff'
                          fillRule='evenodd'
                          d='M9 9V5.002a.999.999 0 1 1 2 0V9h3.998a.999.999 0 1 1 0 2H11v3.998a.999.999 0 1 1-2 0V11H5.002a.999.999 0 1 1 0-2H9z'
                        ></path>
                      </svg>
                      <span>{tr("New project")}</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className='proj-toolbar project-filter-toolbar'>
              {/* Status tabs */}
              <div className='proj-status-tabs'>
                <button className={status == "1" ? "proj-tab proj-tab--active" : "proj-tab"} onClick={(e) => selectOption(e, "1")}>{tr("Active")}</button>
                <button className={status == "2" ? "proj-tab proj-tab--active" : "proj-tab"} onClick={(e) => selectOption(e, "2")}>{tr("Archived")}</button>
                <button className={status == "3" ? "proj-tab proj-tab--active" : "proj-tab"} onClick={(e) => selectOption(e, "3")}>{tr("Both")}</button>
              </div>

              <div className='proj-toolbar-sep' />

              {/* Project search */}
              <div className='proj-search-wrap'>
                <svg width='14' height='14' viewBox='0 0 14 14' fill='none'>
                  <circle cx='6' cy='6' r='4.5' stroke='#9ca3af' strokeWidth='1.5'/>
                  <path d='M10 10l2.5 2.5' stroke='#9ca3af' strokeWidth='1.5' strokeLinecap='round'/>
                </svg>
                <input
                  type='text'
                  className='proj-search-input'
                  data-tour='projects-search'
                  placeholder={tr("Search projects…")}
                  value={projectTerm}
                  onChange={handleProjectTerm}
                />
              </div>

              {showClientFilter && (
                <div className='proj-filter-pill-wrap'>
                  <div
                    className={clientArray.length > 0 ? "proj-filter-pill proj-filter-pill--active" : "proj-filter-pill"}
                    onClick={() => setClientDD(!clientDD)}
                  >
                    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                      <rect x='2' y='7' width='20' height='14' rx='2'/><path d='M16 7V5a2 2 0 0 0-4 0v2'/>
                    </svg>
                    <span>{tr("Client")}</span>
                    {clientArray.length > 0 && (
                      <span className='proj-filter-pill-count'>{clientArray.length}</span>
                    )}
                    <svg className='chevron' width='12' height='12' viewBox='0 0 12 12' fill='none'>
                      <path d='M3 4.5l3 3 3-3' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>
                  </div>

                  {clientDD && (
                    <div className='proj-filter-dropdown'>
                      <div className='proj-filter-dd-head'>
                        <span className='proj-filter-dd-title'>{tr("Filter by client")}</span>
                        <div className='proj-filter-dd-actions'>
                          <a onClick={() => selectAllClient()}>{tr("All")}</a>
                          <a onClick={() => selectNone()}>{tr("Clear")}</a>
                        </div>
                      </div>
                      <div className='proj-filter-dd-search'>
                        <svg width='13' height='13' viewBox='0 0 14 14' fill='none'>
                          <circle cx='6' cy='6' r='4.5' stroke='#9ca3af' strokeWidth='1.5'/>
                          <path d='M10 10l2.5 2.5' stroke='#9ca3af' strokeWidth='1.5' strokeLinecap='round'/>
                        </svg>
                        <input
                          type='text'
                          placeholder={tr("Find client…")}
                          value={searchTerm}
                          onChange={handleSearchTerm}
                          onKeyUp={() => getClientList()}
                          autoFocus
                        />
                      </div>
                      <div className='proj-filter-dd-list'>
                        <div className='proj-filter-dd-item' onClick={() => handleClientCheck(0)}>
                          <div className={`proj-filter-dd-checkbox${clientArray.includes(0) ? ' proj-filter-dd-checkbox--checked' : ''}`}>
                            {clientArray.includes(0) && (
                              <svg width='10' height='10' viewBox='0 0 10 10' fill='none'>
                                <path d='M2 5l2.5 2.5L8 3' stroke='#fff' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                              </svg>
                            )}
                          </div>
                          <span className='proj-filter-dd-label'>{tr("No client")}</span>
                        </div>
                        {clientList.map((item, index) => (
                          <div key={index} className='proj-filter-dd-item' onClick={() => handleClientCheck(item.id)}>
                            <div className={`proj-filter-dd-checkbox${clientArray.includes(item.id) ? ' proj-filter-dd-checkbox--checked' : ''}`}>
                              {clientArray.includes(item.id) && (
                                <svg width='10' height='10' viewBox='0 0 10 10' fill='none'>
                                  <path d='M2 5l2.5 2.5L8 3' stroke='#fff' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                                </svg>
                              )}
                            </div>
                            <span className='proj-filter-dd-label'>{item.display_name || item.company_name || item.client_name}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Clear filters — only shown when active */}
              {(clientArray.length > 0 || projectTerm.length > 0) && (
                <button
                  className='proj-filter-pill'
                  style={{ color: '#9ca3af', borderStyle: 'dashed' }}
                  onClick={() => { selectNone(); setProjectTerm(''); }}
                >
                  <svg width='12' height='12' viewBox='0 0 12 12' fill='none'>
                    <path d='M2 2l8 8M10 2l-8 8' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round'/>
                  </svg>{tr("Clear filters")} </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={
        <Loader />
      }>
      <ProjectList
        reload={reload}
        mode={status}
        projectTerm={projectTerm}
        clientArray={clientArray}
      />
      </Suspense>
      <ProjectModal 
        show={show}
        handleClose={hideModal}
        reloadList={reloadFunction}
      />
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Projects);
